import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export default function HomeIcon(props: IconProps) {
  return (
    <Icon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.72037 3.72417C2.72026 5.17734 1.7202 5.90392 1.32743 6.97718C1.29592 7.06328 1.26758 7.1505 1.24246 7.23868C0.929376 8.33784 1.31136 9.51347 2.07534 11.8647C2.83931 14.216 3.2213 15.3917 4.12066 16.0969C4.19281 16.1534 4.267 16.2073 4.3431 16.2585C5.29172 16.8959 6.52785 16.8959 9.00013 16.8959C11.4724 16.8959 12.7085 16.8959 13.6572 16.2585C13.7333 16.2073 13.8074 16.1534 13.8796 16.0969C14.779 15.3917 15.1609 14.216 15.9249 11.8647C16.6889 9.51347 17.0709 8.33784 16.7578 7.23868C16.7327 7.1505 16.7043 7.06328 16.6728 6.97718C16.2801 5.90392 15.28 5.17734 13.2799 3.72418C11.2798 2.27101 10.2797 1.54442 9.1376 1.50252C9.04598 1.49916 8.95427 1.49916 8.86265 1.50252C7.72054 1.54442 6.72048 2.271 4.72037 3.72417ZM7.50012 12.8022C7.18946 12.8022 6.93762 13.0541 6.93762 13.3647C6.93762 13.6754 7.18946 13.9272 7.50012 13.9272H10.5001C10.8108 13.9272 11.0626 13.6754 11.0626 13.3647C11.0626 13.0541 10.8108 12.8022 10.5001 12.8022H7.50012Z"
        // fill="#FAFAFA"
      />
    </Icon>
  );
}
